import MotorParseable from "./class.MotorParseable";

export default class ColumnConnection extends MotorParseable {
	hasClearButtonDefault() {
		return true;
	}

	isClearButtonEnabled() {
		return this.numUserConnections > 0;
	}

	constructor(options) {
		super(options);

		this.requireAllLeft = false;
		this.columns = [];
		this.numUserConnections = 0;
	}

	getNewDriver() {
		return new Motors.Drivers.ColumnConnectionDriver();
	}

	getStartSignal() {
		this.requireAllLeft = this.model.requireAllLeft || false;

		let columns, labels;
		if (this.model.columns) {
			columns = this.tryJSONParse(this.model.columns, (result) => {
				if (!_.isArray(result)) {
					return [["bad column values"], [":("]];
				} else {
					return result;
				}
			});
			this.columns = columns;
		}
		if (this.model.labels) {
			labels = this.tryJSONParse(this.model.labels, (result) => result);
		}
		let isVertical = this.model.isVertical;

		let allowsMultipleConnections;
		if (this.model.allowsMultipleConnections) {
			allowsMultipleConnections = this.tryJSONParse(
				this.model.allowsMultipleConnections,
				(result) => result
			);
		}

		let connections = this.driverOutputs.connections || {};

		let disabledButtons, disabledConnections;
		if (this.model.disabledButtons) {
			disabledButtons = this.tryJSONParse(
				this.model.disabledButtons,
				(result) => result
			);
		}
		if (this.model.disabledConnections) {
			disabledConnections = this.tryJSONParse(
				this.model.disabledConnections,
				(result) => result
			);
		}

		return {
			columns,
			labels,
			isVertical,
			allowsMultipleConnections,
			heightPx: this.model.heightPx,
			widthPx: this.model.widthPx,
			connections,
			disabledButtons,
			disabledConnections,
		};
	}

	getCachedResponseSignal(data) {
		return {
			connections: data.connections,
		};
	}

	/**
	 * Response and preview should both be strings of sorted arrays.
	 */
	onRenderResponse($responseDiv) {
		this.numUserConnections = this.tryJSONParse(
			this.driverOutputs["connectionPairs"]
		).length;
		this.rerenderClearButton();

		let response, preview;
		if (this.answerKey === "connectionPairs") {
			response = this.driverOutputs[this.answerKey] || "[]";
		}
		if (this.previewKey === "connectionPairs") {
			preview = this.driverOutputs[this.previewKey] || "[]";
		}

		return new Promise((resolve) => {
			if (this.previewKey === "noPreview") {
			} else if (this.isResponseEmpty(response)) {
				$responseDiv.html("<em>No connections made.</em>");
			} else {
				$responseDiv.text(preview);
			}
			this.setSubmittable(this.isResponseSubmittable(response));
			resolve();
		});
	}

	/**
	 * If requireAllLeft is set, then all buttons need to be connected
	 * on their right side (all left buttons are set).
	 * Else, the student can submit as long as the response is nonempty.
	 */
	isResponseSubmittable(response) {
		if (response === undefined) {
			return false;
		} else if (this.answerKey === "connectionPairs") {
			if (this.isResponseEmpty(response)) {
				return false;
			} else if (this.requireAllLeft) {
				const answer = this.tryJSONParse(response);
				const hasRightConnections = this.columns.map((column) =>
					Array.from(column, () => 0)
				);
				answer.forEach((el) => {
					const colIndices = this.getIJ(el[0]);
					hasRightConnections[colIndices[0]][colIndices[1]] = 1;
				});

				for (let i = 0; i < this.columns.length - 1; i++) {
					if (hasRightConnections[i].indexOf(0) > -1) {
						return false;
					}
				}
				return true;
			} else {
				return true;
			}
		}
	}

	isResponseEmpty(response) {
		if (this.answerKey === "connectionPairs") {
			const answer = this.tryJSONParse(response);
			return !answer || answer.length === 0;
		}
	}

	/**
	 * From ColumnConnection motor:
	 *
	 * Helper to get the column and element indices of a button, given its
	 * render index.
	 *
	 * Returns a list [i, j].
	 */
	getIJ(index) {
		if (index < 0) {
			console.log("Error 'getIJ': index " + index);
		}

		let count = this.columns[0].length;

		// Are we in the first column?
		if (index < count) {
			return [0, index];
		}

		// Otherwise, increment columns while counting past buttons.
		let col = 1;
		while (col < this.columns.length) {
			if (index < count + this.columns[col].length) {
				return [col, index - count, 0];
			}
			count += this.columns[col].length;

			col += 1;
		}

		// TODO real error
		// If we get here, we're not in the columns anymore...
		console.log("ERROR getIJ index '" + index + "' overflow");
		return [-1, -1];
	}
}
